import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyVideosAboutYourBrand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 121,
	viewBox: "0 0 140 121",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M71.8584 59.4687L131.327 2.47754",
			stroke: "#A7B0BE",
			strokeWidth: 3,
			strokeLinejoin: "bevel",
			strokeDasharray: "8 7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.7168 104.07L64.4248 66.9023",
			stroke: "#A7B0BE",
			strokeWidth: 3,
			strokeLinejoin: "bevel",
			strokeDasharray: "8 7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4248 115.222V65.6641",
			stroke: "#A7B0BE",
			strokeWidth: 3,
			strokeLinejoin: "bevel",
			strokeDasharray: "8 7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.708 69.3802L128.85 74.3359",
			stroke: "#A7B0BE",
			strokeWidth: 3,
			strokeLinejoin: "bevel",
			strokeDasharray: "8 7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.584 19.8233L64.4247 69.3809",
			stroke: "#A7B0BE",
			strokeWidth: 3,
			strokeLinejoin: "bevel",
			strokeDasharray: "8 7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 63.8055,
			cy: 67.5219,
			r: 8.0531,
			fill: "#A7B0BE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17.9647,
			cy: 19.2035,
			r: 8.0531,
			fill: "#A7B0BE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 131.947,
			cy: 73.7172,
			r: 8.0531,
			fill: "#A7B0BE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 129.001,
			cy: 5.10681,
			r: 5.10681,
			fill: "#A7B0BE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.10681,
			cy: 101.744,
			r: 5.10681,
			fill: "#A7B0BE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 64.576,
			cy: 115.372,
			r: 5.10681,
			fill: "#A7B0BE"
		})
	]
});
export { SvgEmptyVideosAboutYourBrand as ReactComponent };
export { default } from "/home/runner/work/frontend_insights/frontend_insights/apps/insights/src/assets/images/svg/empty-videos-about-your-brand.svg?url";
